export default [
  {
    path: "/guestbook-entry",
    name: "guestbookEntry",
    component: () => import("@/views/guestbook/GuestbookEntryPage.vue"),
    meta: {
      rights: ["ab_create", "c_create"],
      navbarTitle: "Gästebuch Eintrag",
      hideBottomNavigation: true,
      hideAppBar: true,
      fullWidth: true,
      backgroundColor: "#07130d",
    },
  },
]
